
import { FaPlus } from "react-icons/fa6";
import Table from "../../components/Table";
import {
  diagonisisICD10TableHeadData,
  getDiagonisisICD10TableData,
} from "../../constants/data/diagonisisICD10Data";
import AddButton from "../../components/buttons/AddButton";
import PreviousButton from "../../components/buttons/PreviousButton";
import Dashboard from "../../components/Dashboard";
import { useEffect, useState } from "react";
import Diagonisis from "../../components/Modals/Diagonisis";
import { useModal } from "../../context/modalContext";
import { useSelector } from "react-redux";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { Spinner } from "@material-tailwind/react";

function DiagonisisICD10() {
  const { showEditModal, showModal, openModal, closeModal, closeEditModal } =
    useModal();
  const [showSpin, setShowSpin] = useState(false);
  const { token } = useSelector((state) => state.user);
  const [diagonisisICDTableData, setdiagonisisICDTableData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      setShowSpin(true);
      try {
        const { data } = await HttpClient.apiCaller(
          "admin/code?type=ORDER",
          "GET",
          null,
          token,
          null
        );
        console.log(data?.code);
        setdiagonisisICDTableData(data?.code);
      } catch (error) {
        console.log(error);
      } finally {
        setShowSpin(false);
      }
    };

    fetchData();

    return () => { };
  }, [closeModal, closeEditModal]);
  return (
    <Dashboard>
      <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
        <div>
          <p className="poppins-medium text-lg leading-[21px]  text-theme-darkBlue mb-2">
            Manage Diagonisis Order Code{" "}
          </p>
          <p className="poppins-medium text-xs  ">
            <span className="underline  text-theme-blue cursor-pointer">
              Dashboard
            </span>{" "}
            /{" "}
            <span className="underline  text-theme-blue cursor-pointer">
              Manage Diagonisis Order Code
            </span>
          </p>
        </div>
        {/*  */}

        <AddButton
          onClick={openModal}
          buttonName={"Add Diagonisis Order Code"}
          icon={<FaPlus className="size-5" />}
        />
      </div>

      {/*  table */}
      {showSpin ? (
        <div className="w-full mt-20 flex items-center justify-center">
          <Spinner className="h-12 w-12" />{" "}
        </div>
      ) : (
        <Table
          tableData={getDiagonisisICD10TableData(diagonisisICDTableData)}
          tableHeadData={diagonisisICD10TableHeadData}
        />
      )}
      {/*  */}
      {showModal ? <Diagonisis onClose={closeModal} /> : <></>}
      {showEditModal ? (
        <Diagonisis edit={true} onClose={closeEditModal} />
      ) : (
        <></>
      )}
    </Dashboard>
  );
}

export default DiagonisisICD10;
